export function ScalePicker({ label, value, onChange, labels, testid, hint }) {
  return (
    <div data-testid={`${testid}-group`}>
      <div className="flex items-baseline justify-between mb-2.5">
        <span className="text-sm font-semibold text-stone-800">{label}</span>
        <span className="text-xs text-stone-500">{value ? labels[value - 1] : hint || "Tap to rate · optional"}</span>
      </div>
      <div className="grid grid-cols-5 gap-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" data-testid={`${testid}-${n}`} aria-label={`${label} ${labels[n - 1]}`}
            onClick={() => onChange(value === n ? null : n)}
            className={`chip h-12 rounded-2xl border text-sm font-semibold ${value === n ? "bg-stone-900 border-stone-900 text-white" : value && n <= value ? "bg-[#F1E4DD] border-[#E6CFC4] text-stone-800" : "bg-white border-stone-200 text-stone-500 hover:border-stone-400"}`}>
            {n}
          </button>
        ))}
      </div>
    </div>
  );
}

export function ChipGroup({ options, value, onToggle, testid, multi = true }) {
  const isOn = (o) => (multi ? value.includes(o) : value === o);
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button key={o} type="button" data-testid={`${testid}-${o.replace(/\s+/g, "-").toLowerCase()}`} onClick={() => onToggle(o)}
          className={`chip px-3.5 py-2 rounded-full border text-sm capitalize ${isOn(o) ? "bg-[#6E8B74] border-[#6E8B74] text-white" : "bg-white border-stone-200 text-stone-600 hover:border-stone-400"}`}>
          {o}
        </button>
      ))}
    </div>
  );
}
